import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=7ca2e9f6&scoped=true"
import script from "./RecentNews.vue?vue&type=script&lang=js"
export * from "./RecentNews.vue?vue&type=script&lang=js"
import style0 from "./RecentNews.vue?vue&type=style&index=0&id=7ca2e9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca2e9f6",
  null
  
)

export default component.exports